import React, { FunctionComponent } from 'react';

import {
  FlexibleWidthXYPlot,
  HorizontalGridLines,
  XAxis,
  YAxis,
  VerticalBarSeries,
  LabelSeries,
} from 'react-vis';

import { Timeslice } from 'scenes/Report/Report.helper';

import {
  maxScale,
  scalingData,
  tickScalingData,
} from '../PerformanceReports.helper';
import {
  Scale,
  reportColors,
  simpleLabelTransformer,
  labelTransformer,
} from './YearOverYear.helper';

type Props = {
  totalsNearbyByYear: Scale[][];
  totalsOnlineByYear: Scale[][];
  totalTransactions: Scale[];
  timeslice: Timeslice;
  tickFormat: (
    timeslice: Timeslice,
    scales?: Scale[],
  ) => (value: string, index: number) => JSX.Element;
  labelFormat: string;
  height: number;
};

const PlotByVenueType: FunctionComponent<Props> = ({
  totalsNearbyByYear,
  totalsOnlineByYear,
  totalTransactions,
  height,
  timeslice,
  labelFormat,
  tickFormat,
}) => {
  const maxY = maxScale(totalTransactions);
  const years = ['0', '1'];
  const sum = totalsNearbyByYear[0].map(({ y, ...rest }: Scale, index) => {
    return {
      y: y + totalsOnlineByYear[0][index].y,
      ...rest,
    } as Scale;
  });

  const xOffsetAdjusment = Math.round((15 * totalsNearbyByYear[0].length) / 10);
  const yOffset = -10;

  return (
    <FlexibleWidthXYPlot xType="ordinal" height={height} stackBy="y">
      <HorizontalGridLines />
      <XAxis tickFormat={tickFormat(timeslice, totalsOnlineByYear[0])} />
      {years.map((year, index) => (
        <VerticalBarSeries
          color={reportColors[index]}
          data={scalingData(totalsOnlineByYear[index], maxY)}
          cluster={year}
          key={year}
        />
      ))}
      {years.map((year, index) => (
        <VerticalBarSeries
          color={reportColors[index + 2]}
          data={scalingData(totalsNearbyByYear[index], maxY)}
          cluster={year}
          key={year}
        />
      ))}
      <LabelSeries
        labelAnchorX="middle"
        data={simpleLabelTransformer(
          maxY,
          -10 - xOffsetAdjusment,
          yOffset,
          labelFormat,
          totalsOnlineByYear[0],
        )}
      />
      <LabelSeries
        labelAnchorX="middle"
        data={simpleLabelTransformer(
          maxY,
          -10 - xOffsetAdjusment,
          yOffset - 5,
          labelFormat,
          totalsNearbyByYear[0],
        )}
      />
      <LabelSeries
        labelAnchorX="middle"
        data={labelTransformer(
          maxY,
          sum,
          10 + xOffsetAdjusment,
          yOffset,
          labelFormat,
          totalsOnlineByYear[1],
        )}
      />
      <LabelSeries
        labelAnchorX="middle"
        data={simpleLabelTransformer(
          maxY,
          10 + xOffsetAdjusment,
          yOffset,
          labelFormat,
          totalsNearbyByYear[1],
        )}
      />
      <YAxis tickFormat={tickScalingData(totalTransactions, labelFormat)} />
    </FlexibleWidthXYPlot>
  );
};

export default PlotByVenueType;
